import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@/assets/css/customstyles.css";
import "@/assets/css/intelligence-setup-surface.css";
import "../node_modules/vis-network/styles/vis-network.min.css";
import '../node_modules/html2canvas';
// Import the Auth0 configuration
import { domain, clientId, audience, serverUrl } from "./auth/auth_config.json";

// Import the plugin here
import { Auth0Plugin } from "./auth";
import { VuePlausible } from "vue-plausible";
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  serverUrl,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

if (process.env.VUE_APP_USE_ANALYTICS === "true") {
  Vue.use(VuePlausible, {
    domain: "app.tendertrace.com",
    trackLocalhost: false,
    enableAutoPageviews: false,
    enableAutoOutboundTracking: true,
  });
}

Vue.prototype.$safePlausible = {
  trackPageview(payload) {
    if (Vue.prototype.$plausible && typeof Vue.prototype.$plausible.trackPageview === 'function') {
      Vue.prototype.$plausible.trackPageview(payload);
    }
  },
  trackEvent(name, payload) {
    if (Vue.prototype.$plausible && typeof Vue.prototype.$plausible.trackEvent === 'function') {
      Vue.prototype.$plausible.trackEvent(name, payload);
    }
  }
};

export const bus = new Vue();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
